<template>
  <Modal closable>
    <template v-slot:header>
      <h2>{{ $t('route.settings_title') }}</h2>
    </template>

    <div id="route-settings">

      <div class="setting">
        <h4>{{ $t('route.name') }}</h4>
        <input v-model="settings.name" :placeholder="$t('route.name_placeholder')" maxlength="32" />
      </div>

      <div class="setting">
        <h4>{{ $t('route.vehicle') }}</h4>
        <InputSelectHorizontal v-model="settings.vehicle" :options="[
          {display: $t('vehicles.student_truck'), value: 'truck'},
          {display: $t('vehicles.car'), value: 'car'},
          {display: $t('vehicles.bike'), value: 'bike'},
          {display: $t('vehicles.foot'), value: 'foot'}
        ]" />
      </div>
      <p class="hint" v-if="settings.vehicle == 'truck'"><b>{{ $t('vehicles.student_truck') }}</b>: Fartgrænser på 40 km/h ved tættere bebyggelse, 60 km/h på landevej, undgår motor- og motortrafikveje.</p>

      <div class="setting">
        <h4>{{ $t('route.method') }}</h4>
        <InputSelectHorizontal v-model="settings.custom" :options="[
          {display: $t('route.fastest'), value: false},
          {display: $t('route.custom'), value: true},
        ]" />
      </div>

      <div class="divider"></div>
      
      <div class="setting">
        <h4>{{ $t('route.start_time') }}</h4>
        <input v-model="settings.startTime" type="time" style="width:8rem" placeholder="tt:mm" />
      </div>
      
      <div class="setting">
        <h4>{{ $t('route.start_date') }}</h4>
        <input v-model="settings.startDate" type="date" style="width:12rem" />
      </div>

      <div class="divider"></div>

      <div class="setting">
        <h4>{{ $t('route.breaks') }}</h4>
        <InputSelectHorizontal v-model="breaks" :options="[
          {display: $t('route.no_breaks'), value: 'none'},
          {display: $t('route.fixed_breaks') ,value: 'fixed'},
          {display: $t('route.auto_breaks') ,value: 'auto'}
        ]" />
      </div>
      <template v-if="breaks == 'auto'">
        <p class="hint"><b>Automatisk pause:</b> Indtast rutens ønskede varighed. Pauser fordeles ligeligt udfra den resterende tid.</p>
        <div class="setting">
          <h4>{{ $t('route.time_limit') }}</h4>
          <div><input v-model="settings.timeLimit" style="width:5rem" type="number" min="0" /> timer</div>
        </div>
      </template>
      <template v-if="breaks == 'fixed'">
        <p class="hint"><b>Fast pause:</b> Indtast et fast antal minutter hvert stop tillægges.</p>
        <div class="setting">
          <h4>{{ $t('route.break_time') }}</h4>
          <div><input v-model="settings.breakTime" style="width:5rem" type="number" min="0" /> min</div>
          <div v-if="false"><InputTime v-model="settings.breakTime" /></div>
        </div>
      </template>

      <div class="divider"></div>
      <p class="hint"><b>TIP:</b> Du kan altid kan ændre et stops individuelle pause-tid manuelt ved at klikke på stoppet.</p>


    </div>

    <template v-slot:footer>
      <AppButton :loading="saving" @click="save" color="primary">{{ $t("buttons.save_and_close") }}</AppButton>
    </template>
  </Modal>
</template>

<script lang="ts">
import { defineComponent, reactive, ref } from 'vue'
import InputSelectHorizontal from '@/components/inputs/InputSelectHorizontal.vue'
import InputTime from '@/components/inputs/InputTime.vue'

import { store } from '@/store'
import { RouteSettings } from '@/api/tripply/models'
import { compareObjects } from '@/api/tools'

export default defineComponent({
  name: 'RouteSettings',
  components: { InputSelectHorizontal, InputTime },
  props: {
    route: {
      type: Object,
      required: true    
    }
  },
  setup(props) {
    const saving = ref(false)    
    const settings = reactive<RouteSettings>({ ...props.route.settings })
    settings.breakTime /= 60
    settings.timeLimit /= 3600

    const breaks = ref(
      settings.timeLimit > 0 ? 'auto' :
        settings.breakTime > 0 ? 'fixed' :
          'none'
    )

    async function save() {
      saving.value = true
      const updatedSettings = {...settings}
      updatedSettings.breakTime *= 60
      updatedSettings.timeLimit *= 3600
      if (breaks.value == 'fixed') updatedSettings.timeLimit = 0
      if (breaks.value == 'none') {
        updatedSettings.timeLimit = 0
        updatedSettings.breakTime = 0
      } 
      store.route.updateSettings(props.route.id, compareObjects<RouteSettings>(props.route.settings, updatedSettings))
      saving.value = false
      store.modal.hideModal('RouteSettings')
    }

    return { settings, saving, save, breaks }
  }
})
</script>

<style lang="scss" scoped>
.setting {
  margin: 1rem 0;
  justify-content: space-between;
  align-items: center;
  display: flex;
  h4 {
    margin: 0;
    font-size: .9375rem;
  }
}
</style>